<template>
  <div class="floor-group">
    <div class="floor-header">
      <h3 class="floor-title">{{ title }}</h3>
      <span class="room-count">{{ rooms.length }}间</span>
    </div>
    <div class="room-grid">
      <room-card 
        v-for="room in rooms" 
        :key="room.id" 
        :room="room"
        @click="onRoomClick"
      ></room-card>
    </div>
  </div>
</template>

<script>
import RoomCard from './RoomCard.vue'

export default {
  name: 'FloorGroup',
  components: {
    RoomCard
  },
  props: {
    title: {
      type: String,
      required: true
    },
    rooms: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onRoomClick(room) {
      this.$emit('room-click', room);
    }
  }
}
</script>

<style scoped>
.floor-group {
  margin-bottom: 20px;
}

.floor-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.floor-title {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.room-count {
  margin-left: 10px;
  font-size: 14px;
  color: #909399;
}

.room-grid {
  display: flex;
  flex-wrap: wrap;
}
</style> 